<template>
  <b-modal id="AmountUseDetail" size="lg" ref="AmountUseDetail" title="사용처리">
    <b-row class="text-center mb-3">
      <b-col cols="1"></b-col>
      <b-col cols="10">
        <h2>사용 가능 금액 : <span style="color:#c11314">{{selectedBalance | currency}}원</span></h2>
      </b-col>
      <b-col cols="2"></b-col>
    </b-row>
    <b-row class="text-center">
      <b-col cols="2"></b-col>
      <b-col cols="8">
        <b-input-group>
          <b-button variant="primary default" @click="allUse">모두사용</b-button>
          <b-form-input :max="selectedBalance" v-model="useAmount" placeholder="사용할 금액을 입력해주세요" type="number" ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="1"></b-col>
    </b-row>
    <template slot="modal-footer">
      <b-button variant="primary" @click="useProcess">사용처리</b-button>
      <b-button variant="outline-primary" @click="modalHide">닫기</b-button>
    </template>
  </b-modal>
</template>
<script>
  import {currencyFilter } from "../../../utils";

  export default {
    name : "AmountUseDetail" ,
    props : ['selectedBalance'] ,
    filters : {...currencyFilter},
    data() {
      return {
        useAmount : null
      }
    },
    mounted() {
    },
    watch : {
    },
    methods: {

      open(){
        this.useAmount = null
        this.$refs['AmountUseDetail'].show()
      },

      modalHide(){
        this.$refs['AmountUseDetail'].hide()
      },

      allUse(){
        this.useAmount = this.selectedBalance
      },

      useProcess(){
        // if(this.orderNo == null){
        //   alert("주문번호가없습니다")
        //   return
        // }
        // if(this.itemNo == null){
        //   alert("아이템번호가없습니다")
        //   return
        // }
        // if(this.currencyCode == null){
        //   alert("통화코드가없습니다")
        //   return
        // }
        if( this.useAmount === null || this.useAmount < 1 ){
          alert('사용하실 금액을 입력해주세요.')
          return
        }
        if(this.selectedBalance < this.useAmount){
          alert('사용할 금액이 사용 가능 금액보다 많습니다.')
          return
        }
        if( confirm( this.useAmount + ' 원을 사용 처리 하시겠습니까?' ) ) {
          this.$emit('process', this.useAmount)
        }

      }
    }
  }
</script>
